import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, LocalStorage } from 'finpass-angular-services';
import { environment } from '../../environments/environment';
import { NavigationEmitterService } from '../../services/NavigationEmitterService';
import { ChangeModalComponent } from '../change-password/change-password.component';
import { MENU_CONFIG, SUBMENU_CONFIG } from './navigation.config';


@Component({
  selector: 'fpc-navigation',
  template: `<fui-menu class="fpc-navigation">
  <fui-menu-header menu-header (click)="goToDashboard()" [borderless]="!isBO">
    <img [src]="logoUrl" menu-header-logo>
  </fui-menu-header>
  <ng-container *ngFor="let item of menuItems">
    <fui-menu-item
      (click)="goTo(item)"
      *ngIf="hasPermission(item.rules) && !hideInThisURI(item)"
      [active]="getState(item)"
      [hasBadge]="item.badge"
    >
      <span badge *ngIf="item.badge">{{item.badge}}</span>
      <i class="fa fa-2x" [ngClass]="item.icon" icon *ngIf="!item.useFaIconComponent"></i>
      <fa-icon [icon]="item.icon" icon *ngIf="item.useFaIconComponent" style="font-size: 25px;"></fa-icon>
      <span label>{{item.label}}</span>
    </fui-menu-item>
  </ng-container>
  <div class="fpc-navigation__footer" footer>
    <div class="profile-box" (click)="toggleProfileBox()">
      <div class="profile-box-item">
        <div class="profile-box-item__icon">
          <i class="fa fa-2x fa-user-circle"></i>
        </div>
      </div>
      <div class="profile-box-container"
           [ngClass]="{'profile-box-container--open': profileBoxOpen, 'profile-box-container--close': !profileBoxOpen}">
        <div class="profile-box-content">
          <ng-container *ngFor="let subItem of submenuItems, let i = index">
            <div class="profile-box-container-itens" *ngIf="hasPermission(subItem.rules) && !hideInThisURI(subItem)">
              <div class="profile-box-container-item" (click)="goTo(subItem)">
                <span>{{subItem.label}}</span>
              </div>
              <div class="line-separator" *ngIf="i !== submenuItems.length - 1"></div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</fui-menu>
`,
  styles: [`.fpc-navigation__footer .dropdown-toggle::after{display:none}.profile-box{position:relative}.profile-box .profile-box-container{display:inline-table;position:absolute;margin-left:100px;background:#fff;z-index:3;padding:16px;-webkit-box-align:center;align-items:center;justify-items:center;box-shadow:0 2px 3px 0 rgba(128,128,128,.32);width:300px;-webkit-transition:.7s;transition:.7s;-webkit-transition-timing-function:line;transition-timing-function:line}.profile-box .profile-box-container--open{bottom:8px}.profile-box .profile-box-container--close{bottom:-900px}.profile-box .profile-box-container .profile-box-content{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;width:100%;height:100%}.profile-box .profile-box-container .line-separator{height:1px;width:90%;margin-top:2px;margin-bottom:2px;background-color:gray;opacity:.2}.profile-box .profile-box-container .profile-box-container-close{display:-webkit-box;display:flex;width:100%;-webkit-box-pack:end;justify-content:flex-end}.profile-box .profile-box-container .profile-box-container-close i{font-size:32px;color:gray}.profile-box .profile-box-container .profile-box-container-itens{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;width:100%;height:50px}.profile-box .profile-box-container .profile-box-container-item{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;width:100%;height:100%;text-align:center}.profile-box .profile-box-container .profile-box-container-item a,.profile-box .profile-box-container .profile-box-container-item span{text-decoration:none;color:gray}.profile-box .profile-box-container .profile-box-container-item:hover{background-color:#5ae}.profile-box .profile-box-container .profile-box-container-item:hover a,.profile-box .profile-box-container .profile-box-container-item:hover span{color:#fff!important}.profile-box .profile-box-item{width:100%;min-width:120px;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;cursor:pointer}.profile-box .profile-box-item__label{color:#333;font-family:"Nunito Sans";font-size:14px;font-weight:300;line-height:16px;text-align:center}.profile-box .profile-box-item--active{border-bottom:2px solid #f80}.profile-box .profile-box-item--active a,.profile-box .profile-box-item--active div,.profile-box .profile-box-item--active i,.profile-box .profile-box-item--active span{color:#f80}`]
})
export class NavigationComponent implements OnInit {
  @Input() name: string;
  loginInfo: any;
  id: number;
  width: number;
  hasToken: boolean;
  accessType: any;
  accessTypeRoute: any;
  menuItems = MENU_CONFIG;
  submenuItems = SUBMENU_CONFIG;
  profileBoxOpen = false;
  logoUrl: any;
  isBO: boolean;

  constructor(private authService: AuthService,
    private router: Router,
    private activedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: any,
    private localStorage: LocalStorage,
    private modalService: NgbModal,
    private navigationEmitter: NavigationEmitterService
  ) { }

  ngOnInit() {
    this.isBO = this.authService.isBO();
    this.logoUrl = this.getLogoUrl();
    this.width = window.innerWidth;
    this.accessType = this.authService.getType();

    this.loginInfo = this.localStorage.get("loginInfo") || {};
    this.id = this.loginInfo.id;

    this.activedRoute.queryParams.subscribe((params) => {
      this.hasToken = params["hasToken"];
    });

    this.getAccessTypeRoute();
    this.listenerEvents();
  }

  getState(item) {
    return item.activeWhere === location.pathname;
  }

  getAccessTypeRoute() {
    const userType = {
      consultant: 'consultor',
      company: 'empresa',
      operator: 'backoffice',
      investor: 'financiador'
    };

    this.accessTypeRoute = userType[this.accessType];
  }

  goToDashboard() {
    if (this.authService.isCompany() || this.authService.isConsultant()) {
      this.document.location.href = `dashboard`;
      return;
    }

    this.document.location.href = `app/${this.accessTypeRoute}/home`;
  }

  goToConsolidatedOfBids() {
    if (this.authService.isCompany) {
      this.document.location.href = `dashboard/consolidado`;
    }
  }

  goToDataroom() {
    this.document.location.href = `app/${this.accessTypeRoute}/dataroom?id_company=${this.id}`;
  }

  goToCompaniesConsultant() {
    this.document.location.href = `app/${this.accessTypeRoute}/minhas-empresas`;
  }

  goToIndications() {
    this.document.location.href = `app/${this.accessTypeRoute}/indicacoes`;
  }

  goToCompanies() {
    this.document.location.href = `app/${this.accessTypeRoute}/empresas`;
  }

  goToConsultants() {
    this.document.location.href = `app/${this.accessTypeRoute}/consultores`;
  }

  goToOperations() {
    this.document.location.href = `app/${this.accessTypeRoute}/operacoes?is_active=true`;
  }

  goToInvestors() {
    this.document.location.href = `app/${this.accessTypeRoute}/financiadores`;
  }

  goToCreditOperationList() {
    this.document.location.href = `app/${this.accessTypeRoute}/minhas-operacoes`;
  }

  goToCNDList() {
    if (this.authService.isCompany) {
      this.document.location.href = `dashboard/cnd`;
    }
  }

  goToCollaterals() {
    this.document.location.href = `app/${this.accessTypeRoute}/garantias?id_company=${this.id}`;
  }

  goToPendencies() {
    this.document.location.href = `app/${this.accessTypeRoute}/pendencias`;
  }

  goToReferral() {
    this.document.location.href = `app/${this.accessTypeRoute}/indicacoes`;
  }

  goToProfile() {
    this.document.location.href = `app/${this.accessTypeRoute}/perfil?id_company=${this.id}`;
  }

  goToPayment() {
    this.document.location.href = `app/${this.accessTypeRoute}/pagamento`;
  }

  goToConfig() {
    this.document.location.href = `app/${this.accessTypeRoute}/configs`;
  }

  goToEditProfile() {
    if (this.authService.isCompany()) {
      this.document.location.href = `app/${this.accessTypeRoute}/editar-perfil?id_company=${this.id}`;
      return;
    }
    this.document.location.href = `app/${this.accessTypeRoute}/`;
  }

  canDisplayNav(entity) {
    return (this.accessType == entity && !this.hasToken);
  }

  openChangePassword() {
    const modalRef = this.modalService.open(ChangeModalComponent);
  }

  logout() {
    this.authService.logout(true);
  }

  @HostListener('window:resize', ['$event'])
  onResize($event) {
    this.width = $event.target.innerWidth;
  }

  goTo(item: any) {
    if (item.method) {
      this[item.method]();
    }
    if (item.event) {
      this.navigationEmitter.notify(item.event);
    }
  }

  listenerEvents() {
    this.navigationEmitter.data.subscribe(data => {
      if (typeof (data) === 'object' && data.to === 'navigation') {
        this[data.method]();
      }
    })
  }

  hideInThisURI(item) {
    if (!item.hideInURI) {
      return false;
    }
    return item.hideInURI.find(uri => uri.test(window.location.pathname));
  }

  hasPermission(rules: string[]) {
    return rules.includes(this.accessType) && !this.hasToken;
  }

  toggleProfileBox() {
    this.profileBoxOpen = !this.profileBoxOpen;
  }

  getLogoUrl() {
    const { protocol, host } = window.location;
    const baseUrl = environment.env === 'local' ? '' : '/app';
    return `${protocol}//${host}${baseUrl}/assets/finpass/finpass-menu.png`
  }
}
